import React, { useState } from "react";
import List from '../../../../Templates/List';
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap"
import moment from "moment-timezone"
import ToolBar from "../../../../Common/Toolbar";
import ListPagination from "../../../../Templates/List/ListPagination";
import { useGetListLastEventsHome } from "../../../../../hooks/services/sKPI/useOfGAP";
import { __OBJECT_STRUCTURE_GetList } from "../../../../../common/ObjectStructures/Trasnversal";
import CLabel from "../../../../Common/CLabel";
import './style.css'
import { ScrollablePane, ScrollbarVisibility } from "@fluentui/react";
import PropTypes from 'prop-types';
import NoDataLayer from "../../../../Common/NoDataLayer";
import { __BoardEventColor, enum__BoardEventColor } from "../../../../../common/Dictionaries";

function MessageLastEventsBox(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const {
    } = props;

    //Parametros de componente.
    const [fireSearchEvents, setFireSearchEvents] = useState(true);

    const [messageEventList, setMessageEventList] = useState(__OBJECT_STRUCTURE_GetList(10));
    const [numberOfItems, setNumberOfItems] = useState(messageEventList.pageSize);
    const [messageDataLength, setMessageDataLength] = useState(0);

    useGetListLastEventsHome(
        messageEventList.pageNumber,
        numberOfItems, messageEventList,
        setMessageEventList, setNumberOfItems, true,
        fireSearchEvents, setFireSearchEvents);
   
    const onGetMoreData = () => {
        if (messageEventList.data.length !== messageDataLength) {
            setMessageEventList(prevState => ({
                ...prevState,
                data: null,
                fireUpdate: true, 
                totalRecords: messageEventList.data.length + 10,
                totalPages:  (messageEventList.data.length + 10) / messageEventList.pageSize
            }));
            setMessageDataLength(messageEventList.data.length + 10)
        }
    }

    const toolBarItems_Communication  = [
        {
            key: 'showmore',
            text: t('data-lang-btn-showmore'),
            iconProps: { iconName: 'CPlusPlusLanguage' },
            onClick: onGetMoreData,
        },
    ];

    const displayToolBarCommunication = true;

    return (
        <Card className={`mb-2 h-100`}>
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <b>{t('data-lang-lbl-lastevents')}</b>
                    <div className='toolbar'>
                        <ToolBar items={ toolBarItems_Communication } styles={{root: {height: "30px"}}} display={ displayToolBarCommunication } />
                    </div>
                </Card.Title>
            </Card.Header>
            <Card.Body id="listLastEventsGAP" className="h-100">
                <Row>
                    {
                    messageEventList.data !== null && messageEventList.data.length > 0 &&

                        <ScrollablePane
                            style={{minHeight: "320px", maxHeight: "100%", height: "100%"}}
                            styles={{
                                root: { position: "relative" },
                                contentContainer:{overflowX: "hidden"}
                            }}
                            scrollbarVisibility={ScrollbarVisibility.auto}
                            scrollContainerFocus={true}
                        >
                            <List
                                manipulateLocalData={ true }
                                className="no-compact-list"
                                showHeaders={ false }
                                isHeaderVisible={ false }
                                listLocalStoragePageSizeVariableName="lastEventMessages"
                                data={ messageEventList }
                                setData={ setMessageEventList }
                                columns={ [
                                {
                                    key: 'all-props-all-props',
                                    name: t('data-lang-lbl-type'),
                                    fieldName: 'all-props-all-props',
                                    onRender:(item) => {

                                        const color = __BoardEventColor.find(x => x.key === (item.eventModuleId ? item.eventModuleId : enum__BoardEventColor.OTHER))

                                        const html2 =   <Card style={{borderLeft: `10px solid ${ color.text}`}}>
                                                            <Row className='px-1'>
                                                                <Col>
                                                                    <Row>
                                                                        <Col>
                                                                            <Row>
                                                                                <Col xl={12}>{t(item.variableName)}</Col>
                                                                                <Col xl={12} style={{fontSize: "12px"}}>{t(item.eventName)}</Col>
                                                                            </Row>
                                                                        </Col>
                                                                        <Col className='col-auto float-left'>
                                                                            <Row>
                                                                                <Col xl={12} className='text-end'>{moment(item.eventDate).format('DD/MM/YYYY')}</Col>
                                                                                <Col xl={12} className='text-end' style={{fontSize: "12px"}}>{item.eventUsername}</Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </Card>
                        
                                        return  html2;
                                    }
                                }
                            ]} />
                        </ScrollablePane > 
                    }
                    <NoDataLayer display={messageEventList.data === null || messageEventList.data.length === 0} text={t('data-lang-lbl-nodata')} />                   
                </Row>
            </Card.Body>
            <Card.Footer>
                <ListPagination
                    listLocalStoragePageSizeVariableName="lastEventMessages"
                    data={ (messageEventList !== null ? messageEventList : []) }
                    setData={ setMessageEventList } />
            </Card.Footer>
        </Card>
    );
}

///Proptypes
MessageLastEventsBox.propTypes = {
};

export default MessageLastEventsBox;

